"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
var _elementHeadline = _interopRequireDefault(require("../element-headline"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    background: theme.palette.background.light,
    position: "relative",
    "&::before": {
      background: theme.palette.background.light,
      content: "''",
      height: "100%",
      left: -4000,
      position: "absolute",
      top: 0,
      width: 8000,
      zIndex: "-1"
    }
  },
  container: {
    columnGap: theme.spacing(6),
    display: "grid",
    gridTemplateColumns: "1fr",
    padding: theme.spacing(1, 0),
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "1fr 1fr"
    }
  },
  item: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    "& a": {
      alignItems: "center",
      color: theme.palette.text.primary,
      display: "flex",
      padding: theme.spacing(1.5, 1)
    },
    "& a:hover": {
      color: theme.palette.secondary.main
    },
    [theme.breakpoints.down("md")]: {
      "&:last-child": {
        borderBottom: 0
      }
    }
  },
  icon: {
    marginRight: theme.spacing(2)
  },
  arrowIcon: {
    marginLeft: "auto"
  }
}));
const DetectLink = item => {
  const {
    addition,
    id,
    icon,
    reference,
    text,
    title,
    url
  } = item;
  const css = useStyles();
  if (addition === "_blank" || url) {
    var _ref;
    return /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      className: css.item,
      key: id
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: (_ref = text !== null && text !== void 0 ? text : url) !== null && _ref !== void 0 ? _ref : "/",
      target: "_blank",
      rel: "noreferrer"
    }, icon && /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: css.icon,
      src: icon,
      color: "primary",
      size: 24
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h4",
      dangerouslySetInnerHTML: {
        __html: title
      }
    }), /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: css.arrowIcon,
      src: "/img/icons/arrow-right.svg",
      color: "primary",
      size: 20
    })));
  } else if (addition === "mailto") {
    return /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      className: css.item,
      key: id
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: text ? "mailto:" + text : "/"
    }, icon && /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: css.icon,
      src: icon,
      color: "primary",
      size: 24
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h4",
      dangerouslySetInnerHTML: {
        __html: title
      }
    }), /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: css.arrowIcon,
      src: "/img/icons/arrow-right.svg",
      color: "primary",
      size: 20
    })));
  } else {
    var _reference$pageName;
    return /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      className: css.item,
      key: id
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: (_reference$pageName = reference === null || reference === void 0 ? void 0 : reference.pageName) !== null && _reference$pageName !== void 0 ? _reference$pageName : "/"
    }, icon && /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: css.icon,
      src: icon,
      color: "primary",
      size: 24
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h4",
      dangerouslySetInnerHTML: {
        __html: title
      }
    }), /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: css.arrowIcon,
      src: "/img/icons/arrow-right.svg",
      color: "primary",
      size: 20
    })));
  }
};
const References = props => {
  const {
    data,
    hasBackground,
    isExtended
  } = props;
  const {
    elements,
    title
  } = data;
  const matches = (0, _useMediaQuery.default)(theme => theme.breakpoints.up("md"));
  const spacing = matches ? 4 : 0;
  const css = useStyles();
  if (!elements) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: title,
    component: "h2"
  }), /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: hasBackground ? css.root : "",
    mb: 4,
    mt: isExtended ? 0 : 4,
    pt: isExtended ? 0 : spacing,
    pb: spacing
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    className: css.container,
    container: true
  }, elements.map(item => /*#__PURE__*/_react.default.createElement(DetectLink, _extends({
    key: item === null || item === void 0 ? void 0 : item.id
  }, item))))));
};
References.defaultProps = {
  hasBackground: false,
  isExtended: false
};
var _default = exports.default = References;